import { _ } from "libs";
import moment from "moment";

// if today display hour
// if yesterday display yesterday
// if 2 to 6 days old display name of day eg Wed, Thu
// if more then 6 days old, display date Aug 7

export function relativePastTime(time: any) {
	let reference = moment(time),
		now = moment(),
		yesteday = now
			.clone()
			.subtract(1, "days")
			.startOf("day"),
		weekOld = now
			.clone()
			.subtract(6, "days")
			.startOf("day");

	if (reference.isSame(now, "day")) {
		return reference.format("H:mm");
	}

	if (reference.isSame(yesteday, "day")) {
		return _("yesterday");
	}

	if (reference.isAfter(weekOld)) {
		return reference.format("ddd");
	}

	return reference.format("MMM D");
}
